import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BoardsCarouselComponent from "./boards-carousel/boards-carousel-component";
import { StyledBoardsAndQoutesCarouselComponent } from "./boards-and-quotes-carousel-component.scss";
class BoardsAndQoutesCarouselComponent extends PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.activeIndex != prevState.propActiveIndex) {
            return {
                active: nextProps.activeIndex,
                propActiveIndex: nextProps.activeIndex
            };
        }
        return null;
    }
    setActive(active) {
        const { setActive } = this.props;
        if (setActive) {
            setActive(active);
        } else {
            this.setState({
                active
            });
        }
    }
    render() {
        const { quotes, stopAutoSlide, startAutoSlide, showNavigationArrows, removeBoardBorder, aboveTheFold } = this.props;
        const active = Math.min(quotes.length - 1, this.state.active);
        if (!quotes[active]) return false;
        return /*#__PURE__*/ _jsx(StyledBoardsAndQoutesCarouselComponent, {
            className: "boards-and-quotes-carousel-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "boards-carousel-wrapper",
                children: /*#__PURE__*/ _jsx(BoardsCarouselComponent, {
                    quotes: quotes,
                    active: active,
                    setActive: this.setActive,
                    stopAutoSlide: stopAutoSlide,
                    startAutoSlide: startAutoSlide,
                    showNavigationArrows: showNavigationArrows,
                    removeBoardBorder: removeBoardBorder,
                    aboveTheFold: aboveTheFold
                })
            })
        });
    }
    constructor(props){
        super(props);
        var _props_activeIndex;
        this.state = {
            active: (_props_activeIndex = props.activeIndex) !== null && _props_activeIndex !== void 0 ? _props_activeIndex : 0,
            propActiveIndex: props.activeIndex
        };
        this.setActive = this.setActive.bind(this);
    }
}
export { BoardsAndQoutesCarouselComponent as default };
BoardsAndQoutesCarouselComponent.defaultProps = {
    quotes: []
};
